'use strict';

var ConfigurationMarketAssignDirective = function ConfigurationMarketAssignDirective() {
  return {
    template: require('../templates/market-assign.html'),
    restrict: 'E',
    controller: 'ConfigurationMarketAssignController',
    link: function link(scope) {
      scope.$on('configuration-market-assign:saveChanges', scope.save);
    }
  };
};
ConfigurationMarketAssignDirective.$inject = [];
module.exports = ConfigurationMarketAssignDirective;